import * as React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

const MenuLink = ({
  MobileOnly = false,
  children,
  to,
  onClick,
  isActive,
  className,
  ...props
}) => {
  return (
    <Link
      className={
        (MobileOnly && ' inline-block lg:hidden ') +
        (isActive
          ? ' before:content-[""] lg:before:content-none before:absolute before:top-0 before:left-0 before:pl-1 before:bg-red-600 before:h-full lg:bg-red-700 '
          : '') +
        ' pl-3 h-[3.25rem] shrink-0 flex flex-row items-center gap-2 lg:grow lg:menu-link-hover relative lg:py-2 lg:px-3 lg:justify-center fade-in-now lg:animate-none lg:opacity-100 lg:text-white lg:h-auto duration-200 ease-in-out  ' +
        className
      }
      to={to}
      onClick={onClick}
      {...props}
    >
      {children}
    </Link>
  )
}

MenuLink.propTypes = {
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
  MobileOnly: PropTypes.bool,
  className: PropTypes.string,
}

export default MenuLink
